import React from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

interface PrivateRouteProps extends RouteProps {
    component?: any;
    type?: string;
}

export default function PrivateRoute(props: PrivateRouteProps) {
    const { component: Component, ...rest } = props;
    const auth = useAuth();
    return (
        <Route
            {...rest}
            render={(routeProps) =>
                (auth?.currentUser && (props.type ? (props.type === auth?.currentUserRole) : true)) ? (
                    <Component {...routeProps} />
                ) : (
                    <Redirect
                        to='/mobilesignin'
                    />
                )
            }
        />
    )
}
